import { Component, OnInit, Inject } from '@angular/core';

import { LoggerService } from '../services/logger.service';


export class PageNotFoundComponent implements OnInit {
  title = 'Page not found';
  message = 'Sorry, This page is not available';

  constructor( private loggerService: LoggerService) { }

  ngOnInit() {
    this.loggerService.log('... initializing page not found component from shared module.');
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'leaf-layout-page-not-found',
  template: `
  <div class="container text-center">
      <h2>{{title}}</h2>
      <img class="img-responsive" src="assets/images/404-Page-Not-Found.png" class="text-center">
      <h4>{{message}}</h4>
  </div>
  `
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: LoggerService, decorators: [{ type: Inject, args: ['LoggerService', ] }, ]},
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
